import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Media from 'react-media';

import './NavCard.scss';

class NavCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      indexActive: 0,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const indexActive = Number(e.target.id);
    this.setState({ indexActive });
  }

  render() {
    const { dataList } = this.props;
    const { indexActive } = this.state;

    return (
      <div className="navcard container">
        <div className="row">
          <div className="col-lg-2">
            <ul className="navlist">
              {dataList.map((data, i) => {
                return (
                  <li
                    id={i}
                    key={data.id}
                    onClick={this.handleClick}
                    className={`navlist ${indexActive === i ? 'active' : ''}`}
                  >
                    {data.id}
                  </li>
                );
              })}
            </ul>
          </div>
          {/* VR DIVIDER (with fixed height) */}
          <Media query={{ minWidth: '992px' }}>
            {matches =>
              matches && (
                <div
                  style={{
                    borderLeft: '3px solid #C4C4C4',
                    height: '300px',
                  }}
                />
              )
            }
          </Media>
          <div className="col-lg-6">
            {dataList.map((data, i) => {
              return (
                <div
                  key={data.id}
                  className={indexActive === i ? '' : 'hide'}
                  style={{
                    marginLeft: 20,
                    marginRight: 20,
                  }}
                  dangerouslySetInnerHTML={{ __html: data.content }}
                />
              );
            })}
          </div>
          <div className="col-lg">
            {dataList.map((data, i) => {
              return (
                <Img
                  key={data.id}
                  className={indexActive === i ? '' : 'hide'}
                  width="300px"
                  alt={data.image.title}
                  sizes={data.image.sizes}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

NavCard.propTypes = {
  dataList: PropTypes.array.isRequired,
};

export default NavCard;



// WEBPACK FOOTER //
// ./src/components/ui/NavCard.js